import React from 'react';
import { AuctionCampaignStatusCardMap } from '../maps';
import DefaultAuctionCampaignStatusCard from './default';

export function AuctionCampaignStatusCardModule({ publisher_id, ...props }) {
  const Component =
    AuctionCampaignStatusCardMap[publisher_id] || DefaultAuctionCampaignStatusCard;

  return <Component {...props} />;
}
